import React, { useContext } from 'react'
import { Flex, Box, Heading, Text, Button, Image } from 'rebass/styled-components'
import { ThemeContext } from 'styled-components'
import { Input, Textarea, Label } from '@rebass/forms/styled-components'
import { Checkbox } from '@rebass/forms'
// Styled components checkbox doesn't work so utilising ThemeContext to style standard rebass component.
import { useForm } from 'react-hook-form';

const RestorationForm = ({ sendMail }) => {
    const url = typeof window !== 'undefined' ? window.location.href : 'Referring URL not available'
    const { register, handleSubmit, formState: { errors }} = useForm();
    const onSubmit = (data) => sendMail(data, 'contact_form');
    const theme = useContext(ThemeContext);

    return (

        <Box
            mt='lg'
        >
            <Box>
                {/* <AnimationWrapper type="fade-up"> */}
                <Image
                    alt=""
                    decoding="async"
                    loading="lazy"
                    src='https://res.cloudinary.com/kidston/image/upload/v1623931397/website/Restorations/PB_20190313_0095_-_Copy.jpg' />
                {/* </AnimationWrapper> */}
            </Box>
            <Box
                pb={['md', 'md', 'md', 'lg']}
                pl={['md', 'md', 'md', 'lg']}
                pr={['md', 'md', 'md', 'lg']}
                variant="container"
                sx={{
                    position: 'relative',
                }}
            >
                <Box
                    bg="white"
                    pb={['md', 'md', 'md', 'lg']}
                    pl={['md', 'md', 'md', 'lg']}
                    pr={['md', 'md', 'md', 'lg']}
                    pt='md'
                    sx={{
                        marginTop: '-90px',
                    }}
                >
                    <Heading
                        as="h2"
                        pb="md"
                        variant="h2"
                        sx={{
                            textTransform: 'uppercase',
                        }}>Restoration enquiry</Heading>
                    <Flex
                        alignContent="space-between"
                        alignItems="flex-start"
                        as="form"
                        autocomplete="on"
                        // bg="white"
                        flexDirection={['column', 'column', 'row']}
                        onSubmit={handleSubmit(onSubmit)}
                        name="restorationFormRef" // This is for ScrollTo to work.
                    >
                        <Input type="hidden" name="subject" value="New Restoration Enquiry" {...register('subject')} />
                        <Input type="hidden" name="referrer" value={url} {...register('referrer')} />
                        <Box
                            mr={['0', '0', 'sm', 'sm', 'md']}
                            flexBasis={['100%', '100%', '100%', '50%']}

                        >
                            <Text
                                as="label"
                                htmlFor="form-name"
                                hidden
                            >
                                Name
                            </Text>
                            <Input
                                autoComplete="name"
                                enterKeyHint="next"
                                id="form-name"
                                type="text"
                                name="from_name"
                                placeholder="Name" {...register('from_name', { required: true })} />
                            {errors.from_name && <span className="errorMessage">Please enter your name.</span>}

                            <Text
                                as="label"
                                htmlFor="form-email"
                                hidden
                            >
                                Email
                            </Text>
                            <Input
                                autoComplete="email"
                                enterKeyHint="next"
                                id="form-email"
                                type="email"
                                name="reply_to"
                                placeholder="Email" {...register('reply_to', { required: true })} />
                            {errors.reply_to && <span className="errorMessage">Please enter a valid email.</span>}

                            <Text
                                as="label"
                                htmlFor="form-tel"
                                hidden
                            >
                                Telephone
                            </Text>
                            <Input
                                autoComplete="tel"
                                enterKeyHint="next"
                                id="form-tel"
                                type="tel"
                                name="phone"
                                placeholder="Phone" {...register('phone', { required: true })} />
                            {errors.phone && <span className="errorMessage">Please provide a contact number.</span>}

                            <Text
                                as="label"
                                htmlFor="form-manufacturer"
                                hidden
                            >
                                Vehicle manufacturer
                            </Text>
                            <Input
                                id="form-manufacturer"
                                type="text"
                                name="manufacturer"
                                placeholder="Vehicle manufacturer" {...register('manufacturer')} />

                            <Text
                                as="label"
                                htmlFor="form-model"
                                hidden
                            >
                                Vehicle model
                            </Text>
                            <Input
                                type="text"
                                enterKeyHint="next"
                                id="form-model"
                                name="model"
                                placeholder="Vehicle model" {...register('model')} />
                        </Box>
                        <Box
                            mt={['md', 'md', '0']}
                            ml={['0', '0', 'sm', 'sm', 'md']}
                            flexBasis={['100%', '100%', '100%', '50%']}

                        >
                            <Text
                                as="label"
                                htmlFor="form-comments"
                                hidden
                            >
                                Vehicle model
                            </Text>
                            <Textarea
                                enterKeyHint="next"
                                id="form-comments"
                                name="message"
                                placeholder="Comments"
                                type="textarea" {...register('message', { required: true })}
                                sx={{
                                    borderColor: 'aquaMedium',
                                    overflow: 'auto',
                                    minHeight: '115px',
                                    resize: 'vertical',
                                }}
                            />
                            {errors.message && <span className="errorMessage">Please write a brief message so we can respond as swiftly as possible.</span>}
                            <Flex
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <Button
                                    aria-pressed="false"
                                    enterKeyHint="done"
                                    mr="auto"
                                    mt="md"
                                    type="submit"
                                    variant="primary"
                                >Submit</Button>
                                <Box
                                    mt="md">
                                    <Label>
                                        <Flex
                                            alignItems="center"
                                            justifyContent="flex-end"

                                        >
                                            <Text
                                                mx="xs"
                                            >Add me to the Newsletter</Text>
                                        </Flex>
                                        <Flex>
                                            <Checkbox
                                                id="newsletter_consent"
                                                name="newsletter_consent" {...register('newsletter_consent', { required: false })}
                                                mr="0"
                                                sx={{
                                                    'input:checked ~ &': {
                                                        color: theme.colors.aquaDark,
                                                    },
                                                    color: theme.colors.aquaDark,
                                                }
                                                }
                                            />
                                        </Flex>
                                    </Label>
                                </Box>
                            </Flex>
                        </Box>
                    </Flex>
                </Box>
            </Box>
        </Box>
    )
}

export default RestorationForm
